import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeAccessDirective } from './access.directive';
import { CeAccessPipe } from './access.pipe';
import { RequireAccessDirective } from './requireAccess.directive';
import { RequireSysAdminDirective } from './requireSysAdmin.directive';
import { RequireAccessAnyDirective } from './requireAccessAny.directive';
import { RequireStationIdDirective } from './requireStationId.directive';
import { RequireMaintenanceRoleDirective } from './requireMaintenanceRole.directive';

@NgModule({
    declarations: [
        CeAccessDirective,
        CeAccessPipe,
        RequireAccessDirective,
        RequireAccessAnyDirective,
        RequireSysAdminDirective,
        RequireStationIdDirective,
        RequireMaintenanceRoleDirective,
    ],
    imports: [CommonModule],
    exports: [
        CeAccessDirective,
        CeAccessPipe,
        RequireAccessDirective,
        RequireAccessAnyDirective,
        RequireSysAdminDirective,
        RequireStationIdDirective,
        RequireMaintenanceRoleDirective,
    ],
    providers: [CeAccessPipe],
})
export class CeAccessModule {}
